import apiFetch from '../../apiFetch'

export default function (token, processingAgencyId, docTypeUseId, docTypeUse) {
  return apiFetch({ endPoint: `ProcessingAgency/${processingAgencyId}/DocTypeUses/${docTypeUseId}`, method: 'PUT', body: docTypeUse, token: token })
}
